export default __webpack_public_path__ + "static/media/l-5.742f3174.jpg";